/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import { showFormatedDate  } from '../actions/utilAction'
import PaginatorCustom from '../components/paginationCustom';
//import { getOrganizationEncounter } from '../../src/modules/Dashboards/actions/StaffDashboardActions';
import { renderDateField } from '../components/reduxFields';
import { Field, reduxForm } from 'redux-form';
import { RaisedButton } from 'material-ui';
import Tooltip from '../components/Tooltip';
import { getOrganizationOAResponses } from '../../src/modules/Dashboards/actions/StaffDashboardActions';
import moment from 'moment';
import history from '../history';
import SortingCustom from '../components/SortingCustom';
/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */
class OAResponses extends Component {

  constructor(props) {
    super(props);
    this.filter = {
      sort_Column: '',
      sort_order: '', 
    };
    this.setSortColumn = this.setSortColumn.bind(this);
  }

  loadOrganizationOAResponses(page_number) {
    let searchObj = {    
      pageNumber: page_number ? page_number : 1,
      pageSize: 10, 
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: {
        fromDate: this.props.FromOAResponsesDate ? moment(this.props.FromOAResponsesDate).format('YYYY-MM-DD') : new Date(),
        toDate: this.props.ToOAResponsesDate ? moment(this.props.ToOAResponsesDate).format('YYYY-MM-DD') : new Date(),      
      }, 
    };
    this.props.getOrganizationOAResponses(searchObj);
  }

  handleViewClaimClick = (event, obj) => {
    let claimId ='CL' + obj.claimId;
    history.push(`/claims/1/${claimId}`);    
  };


  handleReset = () => {   
    this.props.handleResetOAResponse();
  };

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadOrganizationOAResponses();
    }
  }

  showTableData() {
    return this.props.OrganizationOAResponses.data.map((data) => {
      return (
        <TableRow key={data.id}>       
          <TableRowColumn width="20%">{data.patientName}</TableRowColumn>
          <TableRowColumn width="15%">{showFormatedDate(data.dos)}</TableRowColumn>
          <TableRowColumn width="15%">{'CL' + data.claimId}</TableRowColumn>
          <TableRowColumn width="15%">{data.claimOfficeallyStatus}</TableRowColumn>    
          <TableRowColumn width="15%">{data.submittedAs}</TableRowColumn>                 
          <TableRowColumn width="15%">
            {data.errorReasonDescription !== '' ?
              <Tooltip Description={data.errorReasonDescription} />
              : null} 
          </TableRowColumn>                   
          <TableRowColumn width="5%"><button onClick={(e) => this.handleViewClaimClick(e, data)} type="button" title="View Claim" className="tbactionbtn blackfont"><i className="fa fa-eye" aria-hidden="true"></i></button></TableRowColumn>          
        </TableRow>
      );
    });
  }

  render() {
    return (
      <div>
         <div className="row">
          <div className="col-sm-12">
                <form className="readmin-form custom_form" >                
                  <div className="row end-flex">         
                    <div className="col-sm-4 ml-10">
                      <Field name="FromOAResponsesDate"
                        placeholder="From Date"
                        locale="en-US"
                        selected={this.props.FromOAResponsesDate}
                        onDateChange={this.props.onOAResponseDateChange}
                        openToYearSelection={true}
                        component={renderDateField} />
                    </div>
                    <div className="col-sm-4 ml-10">
                      <Field name="ToOAResponsesDate"
                        placeholder="To Date"
                        locale="en-US"
                        minDate = {this.props.FromOAResponsesDate}
                        selected={this.props.ToOAResponsesDate}
                        openToYearSelection={true}
                        onDateChange={this.props.onOAResponseDateChange}
                        component={renderDateField} />
                    </div>
                    
                    <div className="reset-btn col-sm-4 btn_rt">
                      <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                    </div>
                  </div>
              </form>    
          </div>
        </div>
        <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>            
              <TableHeaderColumn width="20%">
                <SortingCustom noSort={this.props.OrganizationOAResponses && this.props.OrganizationOAResponses.data && !this.props.OrganizationOAResponses.data.length} setSortColumn={this.setSortColumn} columnName='clientName' displayName='Client Name' />
              </TableHeaderColumn>
              <TableHeaderColumn width="15%">
                <SortingCustom noSort={this.props.OrganizationOAResponses && this.props.OrganizationOAResponses.data && !this.props.OrganizationOAResponses.data.length} setSortColumn={this.setSortColumn} columnName='dos' displayName='DOS' />
              </TableHeaderColumn>
              <TableHeaderColumn width="15%">
                <SortingCustom noSort={this.props.OrganizationOAResponses && this.props.OrganizationOAResponses.data && !this.props.OrganizationOAResponses.data.length} setSortColumn={this.setSortColumn} columnName='claimid' displayName='Claim Id' />
              </TableHeaderColumn>              
              <TableHeaderColumn width="15%">Status</TableHeaderColumn>     
              <TableHeaderColumn width="15%">Submitted As</TableHeaderColumn>                   
              <TableHeaderColumn width="15%">Rejected/Denial Reason</TableHeaderColumn>                      
              <TableHeaderColumn width="5%">View</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.props.OrganizationOAResponses && this.props.OrganizationOAResponses.data && this.props.OrganizationOAResponses.data.length > 0 ?
              this.showTableData()              
              : 
              <TableRow>
                <TableRowColumn colSpan="6">No Record Found</TableRowColumn>
              </TableRow>
              }
          </TableBody>
        </Table>
        {this.props.OrganizationOAResponses && this.props.OrganizationOAResponses.data && this.props.OrganizationOAResponses.data.length ?
          <PaginatorCustom data={this.props.OrganizationOAResponses.meta}  handlePageChange={(page_number) => this.loadOrganizationOAResponses(page_number)} />
          : null}
      </div>
    );
  }
}
OAResponses = reduxForm({
  form: 'OAResponsesForm',
})(OAResponses);

function mapStateToProps(state) {

  // console.log('state........',state)
  return {
    OrganizationOAResponses: state.staff_dashboard ? state.staff_dashboard.OrganizationOAResponses : {},
    //BottonPanel_loading: state.staff_dashboard.BottonPanel_loading,    
  }
}

export default connect(mapStateToProps, { getOrganizationOAResponses })(OAResponses);





// WEBPACK FOOTER //
// ./src/adminCharts/OAResponses.js